(function () {
  'use strict';

  var MIN_CHARS   = 3;
  var MAX_RESULTS = 7;
  var DEBOUNCE_MS = 220;

  function init() {
    var input    = document.getElementById('HeaderSearchbarInput');
    var dropdown = document.getElementById('hsb-results');
    if (!input || !dropdown) return;

    var timer       = null;
    var activeIndex = -1;
    var lastQuery   = '';

    /* ── helpers ── */

    function formatPrice(cents) {
      if (!cents && cents !== 0) return '';
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    }

    function getItems() {
      return Array.from(dropdown.querySelectorAll('.hsb-autocomplete__item'));
    }

    function setActive(idx) {
      getItems().forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
      });
      activeIndex = idx;
    }

    function hide() {
      dropdown.hidden = true;
      dropdown.innerHTML = '';
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    /* ── render ── */

    function render(products) {
      dropdown.innerHTML = '';

      if (!products.length) {
        var empty = document.createElement('li');
        empty.className = 'hsb-autocomplete__empty';
        empty.textContent = 'Aucun produit trouvé.';
        dropdown.appendChild(empty);
        dropdown.hidden = false;
        return;
      }

      products.forEach(function (p) {
        var imgSrc  = p.image || null;
        var price   = formatPrice(p.price);
        var editeur = p.editeur || '';
        var title   = p.title  || '';
        var url     = p.url    || '#';

        var li = document.createElement('li');
        li.className = 'hsb-autocomplete__item';
        li.setAttribute('role', 'option');

        var imgHtml = imgSrc
          ? '<img src="' + imgSrc + '" alt="" width="64" height="64" loading="lazy" class="hsb-autocomplete__img">'
          : '<div class="hsb-autocomplete__img hsb-autocomplete__img--placeholder"></div>';

        li.innerHTML =
          '<a href="' + url + '" class="hsb-autocomplete__link">' +
            imgHtml +
            '<div class="hsb-autocomplete__info">' +
              '<span class="hsb-autocomplete__title">' + title + '</span>' +
              (editeur ? '<span class="hsb-autocomplete__vendor">' + editeur + '</span>' : '') +
              (price   ? '<span class="hsb-autocomplete__price">'  + price   + '</span>' : '') +
            '</div>' +
          '</a>';

        dropdown.appendChild(li);
      });

      dropdown.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    /* ── fetch via custom Liquid template (retourne metafields) ── */

    function doSearch(q) {
      var url = '/search?q=' + encodeURIComponent(q) + '&type=product&view=puer-suggest';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== lastQuery) return;
          render(Array.isArray(data) ? data : []);
        })
        .catch(function () { hide(); });
    }

    /* ── events ── */

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQuery = q;
      clearTimeout(timer);

      if (q.length < MIN_CHARS) { hide(); return; }

      timer = setTimeout(function () { doSearch(q); }, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (e) {
      var items = getItems();
      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(Math.min(activeIndex + 1, items.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(Math.max(activeIndex - 1, 0));
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        var link = items[activeIndex].querySelector('a');
        if (link) window.location.href = link.href;
      } else if (e.key === 'Escape') {
        hide();
        input.blur();
      }
    });

    document.addEventListener('click', function (e) {
      var wrap = input.closest('.header-searchbar__wrap');
      if (wrap && !wrap.contains(e.target)) hide();
    });

    input.closest('form').addEventListener('submit', function () { hide(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
